import { render, staticRenderFns } from "./totalClassPage.vue?vue&type=template&id=a73675de&scoped=true&"
import script from "./totalClassPage.vue?vue&type=script&lang=js&"
export * from "./totalClassPage.vue?vue&type=script&lang=js&"
import style0 from "./totalClassPage.vue?vue&type=style&index=0&id=a73675de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a73675de",
  null
  
)

export default component.exports